import { ReactNode } from 'react';
import { AuthSplitLayout } from '@wavvest/shared-auth-ui';
import portfolioChart from '@/assets/login-preview/portfolio-chart.svg';
import './index.scss';

const advisorAccounts = [
  { name: 'Managed Brokerage', amount: '$142,680,400', delta: '+0.6%' },
  { name: 'Retirement Accounts', amount: '$86,412,300', delta: '+0.3%' },
  { name: 'Trust & Estate', amount: '$33,307,300', delta: '+0.5%' },
];

const AumPreview = ({ logoMarkSrc }: { logoMarkSrc: string }) => (
  <div className="advisor-aum-card" aria-hidden="true">
    <div className="advisor-aum-summary">
      <div className="advisor-aum-heading-row">
        <div>
          <div className="advisor-aum-label-row">
            <span className="advisor-aum-label">Total AUM</span>
            <span className="advisor-live-pill">
              <span />
              Live
            </span>
          </div>
          <p className="advisor-aum-value">$262,400,000</p>
          <div className="advisor-aum-delta-row">
            <span className="advisor-aum-delta">+0.44%</span>
            <span>$1,148,200 today</span>
          </div>
        </div>
        <div className="advisor-aum-tabs">
          <span className="is-active">1M</span>
          <span>3M</span>
          <span>1Y</span>
          <span>All</span>
        </div>
      </div>
      <img className="portfolio-chart" src={portfolioChart} alt="" />
    </div>
    <div className="advisor-account-list">
      {advisorAccounts.map((account) => (
        <div className="advisor-account-row" key={account.name}>
          <div className="advisor-account-name">
            <span className="advisor-account-icon">
              <img src={logoMarkSrc} alt="" aria-hidden="true" />
            </span>
            <span>{account.name}</span>
          </div>
          <div className="advisor-account-values">
            <span>{account.amount}</span>
            <strong>{account.delta}</strong>
          </div>
        </div>
      ))}
    </div>
  </div>
);

type AdvisorSignupLayoutProps = {
  activeStep?: number;
  children: ReactNode;
  logoSrc?: string;
  logoFallbackSrc?: string;
  logoAlt?: string;
  brandColor?: string;
  heroImageSrc?: string;
  heroTitle?: string;
  showProgress?: boolean;
};

/** The advisor portal's copy and preview on the shared auth shell. */
export const AdvisorSignupLayout = ({
  activeStep = 1,
  children,
  logoSrc,
  logoFallbackSrc,
  logoAlt = 'Wavvest Weave',
  brandColor,
  heroImageSrc,
  heroTitle,
  showProgress = true,
}: AdvisorSignupLayoutProps) => (
  <AuthSplitLayout
    kicker="Advisor Portal"
    defaultHeroTitle={
      <>
        <span>Built for advisors</span> <em>who build wealth.</em>
      </>
    }
    heroAriaLabel="Advisor portal preview"
    renderHeroPreview={({ logoMarkSrc }) => <AumPreview logoMarkSrc={logoMarkSrc} />}
    activeStep={activeStep}
    logoSrc={logoSrc}
    logoFallbackSrc={logoFallbackSrc}
    logoAlt={logoAlt}
    brandColor={brandColor}
    heroImageSrc={heroImageSrc}
    heroTitle={heroTitle}
    showProgress={showProgress}
  >
    {children}
  </AuthSplitLayout>
);
